import Modal from '@berlitzplatforms/micro.ui.modal'
import Spacer from '@berlitz/spacer'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, ActionContainer } from './style'
import { H3 } from '@berlitz/globals'
import Button from '@berlitz/button'

export interface Prop {
  open: boolean
  onClose: Function
  MINote: string
}

const MINote: React.FC<Prop> = ({ open, MINote, onClose }) => (
  <Modal open={open} onClose={onClose}>
    <Box>
      <H3 disableMargin>
        <FormattedMessage id="MI note" />
      </H3>
      <Spacer size="xxs" />
      <span>{MINote}</span>
      <Spacer size="xxxl" />
      <ActionContainer>
        <Button onClick={onClose}>
          <FormattedMessage id="Ok" />
        </Button>
      </ActionContainer>
    </Box>
  </Modal>
)

export default MINote
